import { useTranslation } from 'react-i18next';

import { useUserDisplay } from '@/entities/user';

interface ToolTypeCellProps {
  isCustom: boolean;
  /** Set for an agent built on the canvas, the only kind that reports who made it. */
  ownerUserId?: string;
}

function CreatedBy({ userId }: { userId: string }) {
  const { t } = useTranslation('admin');
  const { name } = useUserDisplay(userId);

  // Nothing until the name resolves: a placeholder would shift the row on arrival, and an
  // owner who cannot be looked up has nothing worth printing.
  if (!name) return null;

  return (
    <span className="block truncate text-body-sm text-muted-foreground">
      {t('admin.toolsTable.createdBy', { name })}
    </span>
  );
}

export function ToolTypeCell({ isCustom, ownerUserId }: ToolTypeCellProps) {
  const { t } = useTranslation('admin');

  return (
    <div className="flex min-w-0 flex-col gap-3xs">
      <span className="text-body-md">
        {isCustom ? t('admin.toolsTable.custom') : t('admin.toolsTable.system')}
      </span>
      {ownerUserId && <CreatedBy userId={ownerUserId} />}
    </div>
  );
}
